<template>
  <div>

    <vx-card card-border class="mb-4" title="Documentación actual" title-color="dark" collapseAction>
      <vx-card card-border class="mb-2" v-for="(documento, index) in documentos" :key="index">
        <vs-row>
          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2">
            <vs-chip color="primary">{{documento.operador}}</vs-chip>
          </vs-col>
          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="3">
            <vs-chip color="warning">{{documento.nombre}}</vs-chip>
          </vs-col>
          <vs-col vs-type="flex" vs-align="center" vs-w="2">
            <span class="textoVerde"> {{ documento.fichero }} </span>
          </vs-col>
          <vs-col vs-type="flex" vs-align="center" vs-w="3">
            <p>{{documento.descripcion}}</p>
          </vs-col>
          <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="1">
            <feather-icon class="mr-4 hover:text-primary cursor-pointer" @click="descargaDocumento(documento.id, documento.fichero)" icon="DownloadIcon"/>
          </vs-col>
          <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="1">
            <feather-icon icon="Trash2Icon" class="mr-4 hover:text-primary cursor-pointer" @click="confirmarBorrarDocumento(index, documento.id, documento.fichero)"/>
          </vs-col>
        </vs-row>
      </vx-card>
      <div class="vx-row w-full" v-if="documentos === undefined || documentos.length === 0">
        <div class="vx-col w-full">
          <vs-alert color="danger" icon-pack="feather" icon="icon-info">
            <span>No existe ninguna documentación actualmente.</span>
          </vs-alert>
        </div>
      </div>
    </vx-card>

    <vx-card card-border class="mb-2" title="Añadir nuevos documentos" title-color="dark" collapseAction>
      <vx-card  v-for="(documento, index) in fileRecordsForUpload" :key="index" 
        card-border class="mb-2" :title="fileRecordsForUpload[index].file.name" title-color="gray" collapseAction>
        <div class="vx-row mb-4">
          <div class="vx-col sm:w-1/3 w-full">
            <div>
              <span class="campoObligatorio">Operador: *</span>
            </div>
            <div>
              <select-operador v-model="fileRecordsForUpload[index].operador" @input="actualizarOperadorSeleccionado(fileRecordsForUpload[index].operador)"/>
            </div>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            <div>
              <span class="campoObligatorio">Tipo documento: *</span>
            </div>
            <div>
              <v-select class="w-full" 
                v-model="fileRecordsForUpload[index].tipoDocumento" 
                :options="tiposDocumentosPorOperador" 
                placeholder="Seleccione tipo de documento"
                label="nombre"
                :reduce="id => id.id" >
                <div slot="no-options">Seleccione un operador para ver las categorías...</div>
              </v-select>
            </div>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            <div>
              <span>Descripción:</span>
            </div>
            <div>
              <vs-input class="w-full" name="descripcion" v-model="fileRecordsForUpload[index].descripcion" 
                @input="v => { fileRecordsForUpload[index].descripcion = v.toUpperCase()}"/>
            </div>
          </div>
        </div>
      </vx-card>
      <div class="vx-row mt-4">
        <div class="vx-col w-full">
          <VueFileAgent 
            ref="vueFileAgent"
            v-model="fileRecords"
            :multiple="false"
            :maxSize="'15MB'"
            :helpText="'Seleccione ficheros'"
            :errorText="{              
              size: 'Tamaño máximo de 15MB',
            }"
            :deletable="true"
            @select="vueFileAgentFilesSelected($event)"
            @beforedelete="vueFileAgentOnBeforeDelete($event)"
            @delete="vueFileAgentFileDeleted($event)"
          ></VueFileAgent>
        </div>
      </div>

      <!-- Save & Reset Button -->
      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2" @click="guardar" :disabled="!validateForm">Guardar</vs-button>
          </div>
        </div>
      </div>
    </vx-card>

  </div>
</template>

<script>
import valTiposDocumentosStore from '@/store/configuracion/val-tipos-documentos/index.js'
import manualesStore from '@/store/configuracion/manuales/index.js'

import Vue from 'vue'

import vSelect from 'vue-select'
import selectOperador from '@/views/common-components/selectOperador'

// Carga de ficheiros
import VueFileAgent from 'vue-file-agent'
Vue.use(VueFileAgent)
import VueFileAgentStyles from 'vue-file-agent/dist/vue-file-agent.css'

import VueLink from 'vue-link'

export default {
  name: 'OperacionesEditDocumentacion',
  components: {
    VueFileAgentStyles,
    VueLink,
    vSelect,
    selectOperador
  },
  props: {

  },
  data () {
    return {
      // operacion: {},
      documentos: [],
      valTiposDocumentos: [],
      // VueFileAgent
      fileRecords: [],
      fileRecordsForUpload: [],
      operadorSeleccionado: null
    }
  },
  computed: {
    validateForm () {
      if (this.fileRecordsForUpload.length === 0) {
        return false
      } else {
        return true
      }
    },
    tiposDocumentosPorOperador () {
      const tiposDocs = []
      if (this.operadorSeleccionado !== null) {
        this.valTiposDocumentos.forEach(el => { 
          if (el.operador === this.operadorSeleccionado) tiposDocs.push(el)
        })
      }
      return tiposDocs
    }
  },
  methods: {
    actualizarOperadorSeleccionado (operador) {
      this.operadorSeleccionado = operador
    },
    showSuccess (titulo, texto) {
      this.$vs.loading.close()  // Pechamos a animación de 'cargando...'
      this.$vs.notify({
        color: 'success',
        title: titulo,
        text: texto
      })
    },
    showError (titulo, error) {
      this.$vs.loading.close()  // Pechamos a animación de 'cargando...'
      this.$vs.notify({
        color: 'danger',
        title: titulo,
        text: error
      })
    },
    reset_data () {
      this.$router.push({name: 'documentacion'})
    },
    async descargaDocumento (id, nombre) {
      await this.$store.dispatch('manualesStore/downloadDocumento', id)
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data], {type: response.headers['content-type']}))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', nombre)
          document.body.appendChild(link)
          link.click()
        })
        .catch((error) => {
          console.log('ERROR', error)
        })
    },
    vueFileAgentDeleteUploadedFile (fileRecord) {
      // Using the default uploader. You may use another uploader instead.
      this.$refs.vueFileAgent.deleteUpload(this.uploadUrl, this.uploadHeaders, fileRecord)
    },
    vueFileAgentFilesSelected (fileRecordsNewlySelected) {
      const validFileRecords = fileRecordsNewlySelected.filter((fileRecord) => !fileRecord.error)
      this.fileRecordsForUpload = this.fileRecordsForUpload.concat(validFileRecords)
    },
    vueFileAgentOnBeforeDelete (fileRecord) {
      const i = this.fileRecordsForUpload.indexOf(fileRecord)
      if (i !== -1) {
        this.fileRecordsForUpload.splice(i, 1)
        this.fileRecords.splice(i, 1)
      } else {
        this.$refs.vueFileAgent.deleteFileRecord(fileRecord) // will trigger 'delete' event
      }
    },
    vueFileAgentFileDeleted (fileRecord) {
      const i = this.fileRecordsForUpload.indexOf(fileRecord)
      if (i !== -1) {
        this.fileRecordsForUpload.splice(i, 1)
        this.fileRecords.splice(i, 1)
      } else {
        this.vueFileAgentDeleteUploadedFile(fileRecord)
      }
    },
    confirmarBorrarDocumento (index, id, documento) {
      this.documento = { index, id }
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'ATENCIÓN: no se podrá recuperar!',
        text: `¿Seguro que desea eliminar el manual "${documento}"?`,
        accept: this.borrarDocumento,
        parameters: id,
        acceptText: 'Eliminar'
      })
    },
    async borrarDocumento (id) {
      this.$vs.loading('material') // Mostramos unha animación de 'cargando...'

      await this.$store.dispatch('manualesStore/deleteDocumentos', id)
        .then(() => {
          this.inicializar('DOCUMENTO ELIMINADO', 'El documento ha sido eliminado correctamente.')
        })
        .catch((error) => {
          this.showError('ERROR AL ELIMINAR EL DOCUMENTO', error)
        })
    },
    async guardar () {
      if (!this.validateForm) return
      
      const formData = new FormData()
      const datos = []
      let tipoDocumentoVacio = false

      // Revisamos se hai ficheiros para subir
      if (Array.isArray(this.fileRecordsForUpload) && this.fileRecordsForUpload.length > 0) {
        this.fileRecordsForUpload.forEach(element => {  // recorremos os ficheiros a subir        
        // Si non se seleccionou algún tipo de documento non podemos permitir continuar porque se usa para construir a ruta onde se almacena o documento no sistema de ficheiros do servidor
          if (element.tipoDocumento !== undefined) {
            datos.push(JSON.stringify({
              'nombreFichero': element.file.name, 
              'operador': element.operador, 
              'tipoDocumento': element.tipoDocumento, 
              'descripcion': element.descripcion === undefined ? null : element.descripcion,
              'categoria': 'manual'
            }))
            formData.append('ficheiros[]', element.file)    // gardamos o ficheiro físico para enviar
          } else {
            tipoDocumentoVacio = true
          }
        })
      }

      if (!tipoDocumentoVacio) {
        this.$vs.loading('material') // Mostramos unha animación de 'cargando...'
        formData.append('datos[]', datos)

        await this.$store.dispatch('manualesStore/addDocumentos', formData)
          .then(() => {
            this.inicializar('DOCUMENTOS GUARDADOS', 'Los documentos han sido guardados correctamente.')
          })
          .catch((error) => {
            this.showError('ERROR GUARDANDO DOCUMENTOS', error)
          })
      } else {
        this.showError('DATOS INCOMPLETOS', 'Los campos "OPERADOR" y "TIPO DE DOCUMENTO" son obligatorios para todos los ficheros a cargar.')
      }
    },
    async inicializar (titulo, texto) {
      this.fileRecords = []
      this.fileRecordsForUpload = []
      
      await this.$store.dispatch('manualesStore/getDocumentosOrdenados')
        .then(() => {
          this.manuales = JSON.parse(JSON.stringify(this.$store.state.manualesStore.manuales))
          this.manuales.length > 0 ? this.documentos = this.manuales : this.documentos = [] 
          this.showSuccess(titulo, texto)
        })
        .catch((error) => {
          this.showError('ERROR ACTUALIZANDO DATOS', error)
        })        
    }
  },
  async created () {
    if (!valTiposDocumentosStore.isRegistered) {
      this.$store.registerModule('valTiposDocumentosStore', valTiposDocumentosStore)
      valTiposDocumentosStore.isRegistered = true
    }

    if (!manualesStore.isRegistered) {
      this.$store.registerModule('manualesStore', manualesStore)
      manualesStore.isRegistered = true
    }

    await this.$store.dispatch('valTiposDocumentosStore/getTiposDocumentos')
      .then(() => {
        // Recorremos os tipo de documentos e se están activos engadímolas ao combo
        this.$store.state.valTiposDocumentosStore.tiposDocumentos.forEach(element => {
          if (element.activo && element.categoria === 'MANUAL') this.valTiposDocumentos.push(JSON.parse(JSON.stringify(element)))
        })
      })
      .catch((error) => {
        console.log(error)
      })

    await this.$store.dispatch('manualesStore/getDocumentosOrdenados')
    this.manuales = JSON.parse(JSON.stringify(this.$store.state.manualesStore.manuales))
    this.manuales.length > 0 ? this.documentos = this.manuales : this.documentos = [] 
  }
}
</script>

